module.exports = __webpack_public_path__ + "static/img/151.694300e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/151.png
// module id = qEOr
// module chunks = 0